$(document).ready(function(){

//   document.addEventListener("click", function (e) {
//   const btn = e.target.closest(".full_content_read");
//   if (!btn) return;

//   const parent = btn.closest(".highlight-col");
//   if (!parent) return;

//   parent.classList.toggle("active");

//   const label = btn.querySelector("label");

//   if (parent.classList.contains("active")) {
//     label.textContent = "Read Less";
//   } else {
//     label.textContent = "Read Full";
//   }
// });



function initMobileSlider() {
  if (window.innerWidth <= 768) {
    if (!$('.text_icon_column_slider .item-list').hasClass('slick-initialized')) {
      $('.text_icon_column_slider .item-list').slick({
        slidesToShow: 1.5,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        variableWidth: false,   
        autoplay: true,
        autoplaySpeed: 0,     // 🔥 no delay
        speed: 4000,          // 🔥 controls smooth scroll speed
        cssEase: 'linear',    // 🔥 continuous motion

        pauseOnHover: false,
        pauseOnFocus: false,
        swipe: false,         // optional: disable drag for pure auto
        draggable: false
      });
    }
  } else {
    // destroy on desktop
    if ($('.text_icon_column_slider .item-list').hasClass('slick-initialized')) {
      $('.text_icon_column_slider .item-list').slick('unslick');
    }
  }
}

// Run on load
initMobileSlider();

// Run on resize
$(window).on('resize', function () {
  initMobileSlider();
});
});